<template>
  <sup class="h4 fg-red">
    {{ count }}
  </sup>
</template>

<script>
export default {
  name: 'FavoritesCount',
  computed: {
      count() {
          return this.$store.state.added.length
      }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/FavoritesCount.vue